module.exports = __webpack_public_path__ + "assets/img/xf.45666ba0.png";